import { NgModule } from "@angular/core";
import { ACLDirective } from "./acl.directive";
import { WhatappsToDirective } from "./whatapps-to.directive";
import { MailToDirective } from "./mail-to.directive";
import { CallToDirective } from './call-to.directive';
@NgModule({
  imports: [],
  declarations: [
    ACLDirective,
    WhatappsToDirective,
    CallToDirective,
    MailToDirective
  ],
  exports: [
    ACLDirective,
    WhatappsToDirective,
    CallToDirective,
    MailToDirective
  ],
})
export class CustomDirectiveModule {}
